import { storeActions, storeGetters, storeMutations } from '@/store/storeConstants'

export default {
  namespaced: true,
  state: {
    groupBy: null,
    materials: [],
    takeOffs: [],
    otherGroupModel: [],
    assemblyGroupModel: [],
    assemblyModel: [],
    takeOffModel: [],
    projectCostDetails: {
      baseCost: '--',
      sellPrice: '--',
      grossMargin: '--',
    },
    totalManHours: '--',
    projectSize: null,
    keyUnit: '',
    uniqueCharacteristics: [],
    characteristics: [],
    currentCalculator: {},
    otherGroupKey: null,
    originalVendors: {},
    savedTakeOff: {},
    savedAssembly: {},
    takeoffTotal: {
      linear: 0,
      area: 0,
      count: 0
    },
    markupCols: ''
  },
  getters: {
    GET_GROUP_BY: state => {
      return state.groupBy
    },
    GET_MATERIALS: state => {
      return state.materials
    },
    GET_TAKE_OFFS:  state => {
      return state.takeOffs
    },
    GET_PROJECT_COST_DETAILS:  state => {
      return state.projectCostDetails
    },
    GET_TOTAL_MAN_HOURS:  state => {
      return state.totalManHours
    },
    GET_PROJECT_SIZE: state => {
      return state.projectSize
    },
    GET_KEY_UNIT:  state => {
      return state.keyUnit
    },
    GET_GROUP_MODAL: state => {
      return state.otherGroupModel
    },
    GET_ASSEMBLY_GROUP_MODAL: state => {
      return state.assemblyGroupModel
    },
    GET_ASSEMBLY_MODAL: state => {
      return state.assemblyModel
    },
    GET_TAKE_OFF_MODAL: state => {
      return state.takeOffModel
    },
    GET_CURRENT_CALCULATOR: state => {
      return state.currentCalculator
    },
    GET_OTHER_GROUP_KEY: state => {
      return state.otherGroupKey
    },
    GET_UNIQUE_CHAR: state => {
      return state.uniqueCharacteristics
    },
    GET_CHARACTERISTICS:  state => {
      return state.characteristics
    },
    GET_CALCULATOR_SELECTED: state => {
      return Object.hasOwn(state.currentCalculator, 'uuid')
    },
    GET_ORIGINAL_VENDORS: state => {
      return state.originalVendors
    },
    GET_SAVED_TAKE_OFF: state => {
      return state.savedTakeOff
    },
    GET_SAVED_ASSEMBLY: state => {
      return state.savedAssembly
    },
    GET_TAKEOFF_TOTAL: state => {
      return state.takeoffTotal
    },
    GET_MARKUP_COLS: state => {
      return state.markupCols
    }
  },
  mutations: {
    SET_GROUP_BY: (state, payload) => {
      state.groupBy = payload
    },
    SET_MATERIALS: (state, payload) => {
      state.materials = payload
    },
    SET_TAKE_OFFS: (state, payload) => {
      state.takeOffs = payload
    },
    SET_PROJECT_COST_DETAILS: (state, payload) => {
      state.projectCostDetails = payload
    },
    SET_TOTAL_MAN_HOURS: (state, payload) => {
      state.totalManHours = payload
    },
    SET_PROJECT_SIZE: (state, payload) => {
      state.projectSize = payload
    },
    SET_KEY_UNIT: (state, payload) => {
      state.keyUnit = payload
    },
    SET_GROUP_MODAL: (state, payload)  => {
      state.otherGroupModel = payload
    },
    SET_ASSEMBLY_GROUP_MODAL: (state, payload)  => {
      state.assemblyGroupModel = payload
    },
    SET_ASSEMBLY_MODAL: (state, payload) => {
      state.assemblyModel = payload
    },
    SET_TAKE_OFF_MODAL: (state, payload) => {
      state.takeOffModel = payload
    },
    SET_CURRENT_CALCULATOR: (state, payload) => {
      state.currentCalculator = payload
    },
    SET_UNIQUE_CHAR: (state, payload) => {
      state.uniqueCharacteristics = payload
    },
    SET_CHARACTERISTICS: (state, payload) => {
      state.characteristics = payload
    },
    SET_OTHER_GROUP_KEY: (state, payload) => {
      state.otherGroupKey = payload
    },
    SET_ORIGINAL_VENDORS: (state, payload) => {
      state.originalVendors = payload
    },
    ADD_ORIGINAL_VENDOR: (state, { key, vendorInfo }) => {
      state.originalVendors[key] = vendorInfo
    },
    RESET_ORIGINAL_VENDORS: (state) => {
      state.originalVendors = {}
    },
    SET_SAVED_TAKE_OFF: (state, payload) => {
      state.savedTakeOff = payload
    },
    SET_SAVED_ASSEMBLY: (state, payload) => {
      state.savedAssembly = payload
    },
    ADD_SAVED_TAKE_OFF: (state, { key, takeOffData }) => {
      state.savedTakeOff[key] = takeOffData
    },
    ADD_SAVED_ASSEMBLY: (state, { key, assemblyData }) => {
      state.savedAssembly[key] = assemblyData
    },
    REMOVE_SAVED_TAKE_OFF: (state, key) => {
      delete state.savedTakeOff[key]
    },
    REMOVE_SAVED_ASSEMBLY: (state, key) => {
      delete state.savedAssembly[key]
    },
    RESET_SAVED_VENDORS: (state) => {
      state.savedTakeOff = {}
      state.savedAssembly = {}
    },
    SET_TAKEOFF_TOTAL: (state, payload) => {
      state.takeoffTotal = payload
    },
    SET_MARKUP_COLS: (state, payload) => {
      state.markupCols = payload
    },
  },
  actions: {

  },
}
